/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Event_StartInputs */

const en_snap_to_event_start = /** @type {(inputs: Snap_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap to Event Start`)
};

const fr_snap_to_event_start = /** @type {(inputs: Snap_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner sur le début de l'événement`)
};

const de_snap_to_event_start = /** @type {(inputs: Snap_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An Ereignisstart anheften`)
};

const it_snap_to_event_start = /** @type {(inputs: Snap_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggancia all'inizio dell'evento`)
};

const ru_snap_to_event_start = /** @type {(inputs: Snap_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к началу мероприятия`)
};

const es_snap_to_event_start = /** @type {(inputs: Snap_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar al inicio del evento`)
};

const zh_cn2_snap_to_event_start = /** @type {(inputs: Snap_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快照到事件开始`)
};

const ja_snap_to_event_start = /** @type {(inputs: Snap_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント開始にスナップ`)
};

const hi_snap_to_event_start = /** @type {(inputs: Snap_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट शुरू होने पर क्लिक करें`)
};

const pt_pt2_snap_to_event_start = /** @type {(inputs: Snap_To_Event_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o início do evento`)
};

/**
* | output |
* | --- |
* | "Snap to Event Start" |
*
* @param {Snap_To_Event_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_start = /** @type {((inputs?: Snap_To_Event_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_event_start(inputs)
	if (locale === "de") return de_snap_to_event_start(inputs)
	if (locale === "it") return it_snap_to_event_start(inputs)
	if (locale === "ru") return ru_snap_to_event_start(inputs)
	if (locale === "es") return es_snap_to_event_start(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_event_start(inputs)
	if (locale === "ja") return ja_snap_to_event_start(inputs)
	if (locale === "hi") return hi_snap_to_event_start(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_event_start(inputs)
	return en_snap_to_event_start(inputs)
});